import React, { ReactElement, ReactNode, createContext, useContext } from 'react';

const InternalReaderContext = createContext(false);

/** Marks a subtree as read by one of us: the client-scoped endpoints answer 403 to everybody but the client. */
export const InternalReaderProvider = ({ children }: { children: ReactNode }): ReactElement => (
  <InternalReaderContext.Provider value>{children}</InternalReaderContext.Provider>
);

export const useIsInternalReader = (): boolean => useContext(InternalReaderContext);
